import Vue from 'vue'
import Router from 'vue-router'
// import Home from './components/Home.vue'
import Start from './components/Start.vue'
import Print from './components/Print.vue'
import multiPrint from './components/MultiPrint.vue'
import About from './views/About.vue'
// import bheader from './components/bheader'

Vue.use(Router)
export default new Router({
  hashbang: false,
  mode: 'history',
  base: '/lockets1',
  routes: [
    {
      path: '/',
      name: 'home',
      // component: 
      component: About
    },{
      path: '/create/:storeType',
      name: 'create',
      component: Start
    },{
      path: '/create/:storeType/:selectedStyleNum',
      name: 'create',
      component: Start
    },
    {
      path: '/edit/:confirmationNum',
      name: 'edit',
      component: Start
    },
    {
      path: '/print/:confirmationNum/:papersize',
      name: 'print',
      component: Print
    },
    {
      path: '/print/:confirmationNum/preview',
      name: 'preview',
      component: Print
    },
    {
      path: '/factoryPrint',
      name: 'factoryPrint',
      component: multiPrint
    },
    {
      path: '*',
      name: 'home',
      // component: 
      component: About
    }
  ]
})
